module.exports = __webpack_public_path__ + "img/sorry.5613b8c6.png";